import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("App error:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-ink text-bone flex items-center justify-center p-8">
          <div className="text-center max-w-md">
            <div className="font-display text-2xl text-gold tracking-widest mb-3">BLACKBEARD</div>
            <p className="text-mut mb-6">Algo salió mal. Recarga la página para continuar.</p>
            <button
              data-testid="error-reload-button"
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-gold text-ink font-semibold rounded-full"
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
